import { Line } from 'react-chartjs-2'
import { Divider, Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableIndustry from '../../Tables/TableIndustry'

const TotalIndustryByZones = props => {
  const { selectedDate, gTeriitoryB, gTeriitoryA, tableTerritory } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total Industria por Zonas</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          {tableTerritory.map((value, index) => (
              <>
                {value[0].datos.length > 1 ? (
                  <>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Divider />
                      <h6>{value[0].territorio}</h6>
                      <Divider />
                      <TableIndustry
                        array={value[0].datos}
                        selectedDate={selectedDate}
                        title={value[0].territorio}
                        param="EMPRESA"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <h3>Evolución del mercado total en miles</h3>
                      <br />
                      <Line
                        data={Utils.customBarLineDataGroup(
                          gTeriitoryA[index],
                          'EMPRESA',
                          'PORCENTAJE',
                          'y',
                          '100',
                        )}
                        options={Utils.optionsLine}
                      />{' '}
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <h3>Evolución del mercado total en miles</h3>
                      <br />
                      <Line
                        data={Utils.customBarLineDataGroup(gTeriitoryB[index], 'EMPRESA', 'PORC', 'MES', '100')}
                        options={Utils.optionsLine}
                      />{' '}
                    </Grid>
                    <Divider />
                  </>
                ) : null}
              </>
            ))}
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalIndustryByZones
